// extracted by mini-css-extract-plugin
export default {"createDateRangePicker":"style_createDateRangePicker__hSvLy"};